import styled from 'styled-components';

import { TenorGIF, useTenorGifs } from '../../../../hooks/useTenorGIFs';
import { Button } from '../../../_atoms/Button';

export const GIFRow = ({
  onGifSelected,
  onClickSeeMore,
}: {
  onClickSeeMore: () => void;
  onGifSelected: (gif: TenorGIF) => void;
}) => {
  const { data } = useTenorGifs();

  return (
    <RowContainer>
      <TitleContainer>
        <span style={{ padding: '1%' }}>GIFs</span>
        <Button
          onClick={() => {
            onClickSeeMore();
          }}
          styles={{ fontSize: 12 }}
          type="ghost"
        >
          Browse all
        </Button>
      </TitleContainer>
      <GifCarousel>
        {data?.data.map(gif => (
          <GifItem
            key={gif.id}
            src={gif.media_formats.tinygif.url}
            alt={gif.title}
            height={70}
            onClick={() => onGifSelected(gif)}
          />
        ))}
      </GifCarousel>
    </RowContainer>
  );
};

const GifCarousel = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 6px;
  overflow-y: hidden;
  overflow-x: auto;
  padding-bottom: 8px;
`;

const GifItem = styled.img`
  border-radius: 5px;
  overflow: clip;
  cursor: pointer;
`;

const RowContainer = styled.div`
  height: 100px;
`;

const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    border: none;
    padding: 0px 10px;
    margin-bottom: 2px;
    box-shadow: none;
  }
`;
